import { Flex, Grid, Stack, Text, Title } from '@mantine/core'
import { ShippingMethod } from '@medusajs/medusa'
import { LiteProductVariant } from '@ortros/stoux-lib'

import formatAmount from '@/utils/format-amount'

import { AnimatePresence } from 'motion/react'
import ListLineItemView from './ListLineItem'
import { getStore } from '@/utils/store'

type Props = {
    readonly: boolean
    items: Record<string, (LiteProductVariant & { template_barcode: string })[]>
    showShippingTaxes?: boolean
    shippingMethods?: ShippingMethod[]
    onRemove?: (item: LiteProductVariant) => void
}

const ListLineItems = (props: Props) => {
    const hasItems = Object.keys(props.items).length > 0
    const store = getStore()
    return (
        <Grid
            aria-label="Cart Line Items"
            data-testid="cart-line-items"
            className="w-full p-4 m-0 gap-y-8"
        >
            {hasItems &&
                Object.entries(props.items).map(([storeId, value]) => {
                    const linkedShippingMethods =
                        props.shippingMethods?.filter((sm) => {
                            return sm.data.store_id === storeId
                        }) ?? []

                    const totalShippingCost = linkedShippingMethods?.reduce(
                        (acc, curr) => acc + curr.total!,
                        0,
                    )

                    return (
                        <Stack
                            key={storeId}
                            className="w-full px-5 py-4 text-left rounded"
                            role="list"
                            style={{
                                border: '1px dashed #e2e8f0',
                            }}
                        >
                            <Stack className="gap-y-4 lg:gap-y-8">
                                <AnimatePresence mode="popLayout">
                                    {value.map((item) => (
                                        <ListLineItemView
                                            key={item.id}
                                            dataSource={item}
                                            onRemove={
                                                !props.readonly
                                                    ? () =>
                                                          props.onRemove &&
                                                          props.onRemove(item)
                                                    : () => null
                                            }
                                            readonly={props.readonly}
                                        />
                                    ))}
                                </AnimatePresence>
                            </Stack>
                            <Flex className="flex-row-reverse items-center justify-between">
                                {props.showShippingTaxes && (
                                    <Stack spacing={0} className="text-right">
                                        <Text className="text-xs" c="gray.6">
                                            Frais de livraison
                                        </Text>

                                        <Title
                                            order={6}
                                            c="gray.8"
                                            className="break-all"
                                        >
                                            {formatAmount(totalShippingCost)}{' '}
                                            <small className="text-gray-400">
                                                (TTC)
                                            </small>
                                        </Title>
                                    </Stack>
                                )}

                                {!store && (
                                    <Stack spacing={0} mr="auto" mt="sm">
                                        <Text className="text-xs" c="gray.6">
                                            Vendu par
                                        </Text>
                                        <Title
                                            order={6}
                                            c="gray.8"
                                            className="break-all"
                                        >
                                            {value[0].store_name}
                                        </Title>
                                    </Stack>
                                )}
                            </Flex>
                        </Stack>
                    )
                })}
        </Grid>
    )
}

ListLineItems.defaultProps = {
    readonly: false,
}

export default ListLineItems
